(function () {
  function initStaffelBlock(root) {
    if (!(root instanceof HTMLElement) || root.dataset.staffelInitialized === 'true') return;
    root.dataset.staffelInitialized = 'true';

    var dataEl = root.querySelector('#variant-staffel-data');
    var container = root.querySelector('.staffel-container');
    var heading = root.querySelector('.staffel-legend');
    var summaryContainer = root.querySelector('#selection-summary');
    var selectionTextEl = root.querySelector('#dynamic-selection-text');
    var img1 = root.querySelector('#staffel-img-1');
    var img2 = root.querySelector('#staffel-img-2');
    var img3 = root.querySelector('#staffel-img-3');
    var badge2 = root.querySelector('#badge-2');
    var badge3 = root.querySelector('#badge-3');
    var boxes = Array.from(root.querySelectorAll('.staffel-box'));
    var productContext = root.closest('.product-details') || root.closest('.shopify-section') || document;
    var productId = root.dataset.productId || '';
    var currentQuantity = 1;

    if (!dataEl || !container || boxes.length === 0) return;

    var staffelData;
    try {
      staffelData = JSON.parse(dataEl.textContent || dataEl.innerHTML || '{}');
    } catch (error) {
      console.error('Staffel JSON parse error', error);
      return;
    }

    function getProductForm() {
      return (
        productContext.querySelector('product-form-component[data-product-id="' + productId + '"]') ||
        productContext.querySelector('product-form-component')
      );
    }

    function getVariantIdInput() {
      var form = getProductForm();
      return form ? form.querySelector('input[name="id"]') : null;
    }

    function getQuantityComponent() {
      var form = getProductForm();
      return form ? form.querySelector('quantity-selector-component') : null;
    }

    function getQuantityInput() {
      var quantityComponent = getQuantityComponent();
      return quantityComponent ? quantityComponent.querySelector('input[name="quantity"]') : null;
    }

    function getProductPrice() {
      return (
        productContext.querySelector('product-price[data-product-id="' + productId + '"]') ||
        productContext.querySelector('product-price')
      );
    }

    function getCurrentVariantId() {
      var variantIdInput = getVariantIdInput();
      if (variantIdInput && variantIdInput.value) return String(variantIdInput.value);
      return dataEl.dataset.defaultVariantId || null;
    }

    function getCurrentQuantity() {
      var quantityInput = getQuantityInput();
      if (quantityInput) return Math.max(1, parseInt(quantityInput.value, 10) || 1);
      return currentQuantity;
    }

    function formatMoney(cents) {
      var currency =
        (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || document.documentElement.getAttribute('data-currency') || 'EUR';
      var locale = document.documentElement.lang || 'de-DE';

      try {
        return new Intl.NumberFormat(locale, {
          style: 'currency',
          currency: currency,
        }).format((Number(cents) || 0) / 100);
      } catch (error) {
        return ((Number(cents) || 0) / 100).toFixed(2).replace('.', ',') + ' €';
      }
    }

    /**
     * @param {number} cents
     * @param {{reference_value?: number, reference_unit?: string}|null|undefined} measurement
     */
    function formatUnitPrice(cents, measurement) {
      if (!measurement || !measurement.reference_unit) return null;
      var referenceValue = Number(measurement.reference_value) || 1;
      var referencePrefix = referenceValue === 1 ? '' : String(referenceValue);
      return formatMoney(cents) + '/' + referencePrefix + measurement.reference_unit;
    }

    /**
     * @param {any} config
     * @param {number} totalWithoutStaffel
     * @param {number} finalPrice
     */
    function updateUnitPriceDisplay(config, totalWithoutStaffel, finalPrice) {
      var productPrice = getProductPrice();
      if (!productPrice || !config || !config.unit_price) return;

      var unitPriceEl = productPrice.querySelector('[ref="unitPrice"], .product-price-block__unit-price');
      if (!unitPriceEl) return;

      // Cache the server-rendered (or variant-swap-synced) original text once per element,
      // so we can restore it exactly when the staffel discount is removed again.
      if (!unitPriceEl.hasAttribute('data-original-unit-price-text')) {
        unitPriceEl.setAttribute('data-original-unit-price-text', unitPriceEl.textContent || '');
      }

      var ratio = totalWithoutStaffel > 0 ? finalPrice / totalWithoutStaffel : 1;

      if (ratio >= 1) {
        unitPriceEl.textContent = unitPriceEl.getAttribute('data-original-unit-price-text');
        return;
      }

      var newUnitPrice = Math.round(Number(config.unit_price) * ratio);
      var formatted = formatUnitPrice(newUnitPrice, config.unit_price_measurement);
      if (formatted) unitPriceEl.textContent = formatted;
    }

    function getDiscountRates(config) {
      var logicArray = Array.isArray(config && config.logic) ? config.logic : [];
      var logicKey = logicArray[0] || config.logic || null;

      if (logicKey === 'option_01') return [0, 0.05, 0.1];
      if (logicKey === 'option_02') return [0, 0.1, 0.15];
      return null;
    }

    function setVisibility(visible) {
      container.style.setProperty('display', visible ? 'flex' : 'none', 'important');
      if (heading) heading.style.setProperty('display', visible ? 'block' : 'none', 'important');
      if (summaryContainer) {
        summaryContainer.style.setProperty('display', visible ? 'block' : 'none', 'important');
      }
    }

    function updateImages(config) {
      if (img1 && config.img1) img1.src = config.img1;
      if (img2 && config.img2) img2.src = config.img2;
      if (img3 && config.img3) img3.src = config.img3;
    }

    function updateBadges(discountRates) {
      if (badge2) badge2.textContent = '-' + Math.round(discountRates[1] * 100) + '%';
      if (badge3) badge3.textContent = '-' + Math.round(discountRates[2] * 100) + '%';
    }

    function updateSelectionSummary(config, quantity) {
      if (!selectionTextEl) return;
      var variantTitle = (config && config.title) || '';
      selectionTextEl.textContent = quantity + ' x ' + variantTitle;
    }

    /**
     * Combines the variant's own compare-at discount (if any) with the staffel
     * discount into a single percentage and writes it into the existing badge,
     * preserving that badge's original locale wording (e.g. "-{n}%" vs "{n}% off").
     * @param {boolean} showComparePrice
     * @param {number} totalComparePrice
     * @param {number} finalPrice
     */
    function updateDiscountBadge(showComparePrice, totalComparePrice, finalPrice) {
      var productPrice = getProductPrice();
      if (!productPrice) return;

      var badgeEl = productPrice.querySelector('.product-badges__badge');
      if (!badgeEl) return;

      if (!badgeEl.hasAttribute('data-original-badge-text')) {
        badgeEl.setAttribute('data-original-badge-text', badgeEl.textContent || '');
      }

      var originalText = badgeEl.getAttribute('data-original-badge-text') || '';

      if (!showComparePrice || totalComparePrice <= 0 || finalPrice >= totalComparePrice) {
        badgeEl.textContent = originalText;
        return;
      }

      var combinedPercent = Math.round(((totalComparePrice - finalPrice) / totalComparePrice) * 100);
      badgeEl.textContent = originalText.replace(/\d+([.,]\d+)?/, String(combinedPercent));
    }

    function updatePriceDisplay(config, quantity, staffelDiscount) {
      var productPrice = getProductPrice();
      if (!productPrice || !config) return;

      var regularContainer = productPrice.querySelector('.price__regular');
      var regularPrice = productPrice.querySelector('.price__regular .price');
      var saleContainer = productPrice.querySelector('.price__sale');
      var salePrice = productPrice.querySelector('.price__sale .price-item--sale.price');
      var comparePrice = productPrice.querySelector('.price__sale .compare-at-price, .compare-at-price');

      var basePrice = Number(config.price) || 0;
      var baseComparePrice = Number(config.compare_at_price) || 0;

      if (!basePrice) return;

      var totalWithoutStaffel = basePrice * quantity;
      var staffelDiscountAmount = Math.ceil(totalWithoutStaffel * staffelDiscount);
      var finalPrice = totalWithoutStaffel - staffelDiscountAmount;
      var effectiveCompareBase = baseComparePrice > basePrice ? baseComparePrice : basePrice;
      var totalComparePrice = effectiveCompareBase * quantity;
      var showComparePrice = staffelDiscount > 0 || baseComparePrice > basePrice;

      if (showComparePrice) {
        if (salePrice) salePrice.textContent = formatMoney(finalPrice);
        if (comparePrice) {
          comparePrice.textContent = formatMoney(totalComparePrice);
          comparePrice.style.display = 'inline-block';
        }
        if (saleContainer) saleContainer.classList.remove('price__hidden');
        if (regularContainer) regularContainer.classList.add('price__hidden');
      } else {
        if (regularPrice) regularPrice.textContent = formatMoney(finalPrice);
        if (comparePrice) comparePrice.style.display = 'none';
        if (regularContainer) regularContainer.classList.remove('price__hidden');
        if (saleContainer) saleContainer.classList.add('price__hidden');
      }

      updateUnitPriceDisplay(config, totalWithoutStaffel, finalPrice);
      updateDiscountBadge(showComparePrice, totalComparePrice, finalPrice);
    }

    function syncActiveBox(quantity) {
      boxes.forEach(function (box) {
        box.classList.remove('is-active');
      });

      if (quantity === 1 && boxes[0]) boxes[0].classList.add('is-active');
      if (quantity === 2 && boxes[1]) boxes[1].classList.add('is-active');
      if (quantity >= 3 && boxes[2]) boxes[2].classList.add('is-active');
    }

    function render() {
      var variantId = getCurrentVariantId();
      if (!variantId) {
        setVisibility(false);
        return;
      }

      var config = staffelData[String(variantId)];
      var discountRates = getDiscountRates(config);
      var quantity = getCurrentQuantity();
      var discountIndex = Math.min(Math.max(quantity - 1, 0), 2);
      var staffelDiscount = discountRates ? discountRates[discountIndex] || 0 : 0;

      syncActiveBox(quantity);

      if (!config || !discountRates) {
        setVisibility(false);
        return;
      }

      updateImages(config);
      updateBadges(discountRates);
      updateSelectionSummary(config, quantity);
      updatePriceDisplay(config, quantity, staffelDiscount);
      setVisibility(true);
    }

    function setQuantity(quantity) {
      currentQuantity = quantity;

      var quantityComponent = getQuantityComponent();
      var quantityInput = getQuantityInput();

      if (quantityInput) {
        quantityInput.value = String(quantity);
        if (typeof quantityComponent.onQuantityChange === 'function') {
          quantityComponent.onQuantityChange();
        }
        if (typeof quantityComponent.updateButtonStates === 'function') {
          quantityComponent.updateButtonStates();
        }
      } else {
        var productFormEl = getProductForm();
        if (productFormEl) {
          var directInput = productFormEl.querySelector('input[name="quantity"]');
          if (directInput) {
            directInput.value = String(quantity);
          } else {
            var actualForm = productFormEl.querySelector('form');
            if (actualForm) {
              var staffelInput = actualForm.querySelector('input[data-staffel-quantity]');
              if (staffelInput) {
                staffelInput.value = String(quantity);
              } else {
                var hiddenInput = document.createElement('input');
                hiddenInput.type = 'hidden';
                hiddenInput.name = 'quantity';
                hiddenInput.setAttribute('data-staffel-quantity', 'true');
                hiddenInput.value = String(quantity);
                actualForm.appendChild(hiddenInput);
              }
            }
          }
        }
      }

      render();
    }

    boxes.forEach(function (box, index) {
      box.addEventListener('click', function () {
        setQuantity(index + 1);
      });
    });

    var quantityComponent = getQuantityComponent();
    if (quantityComponent) {
      quantityComponent.addEventListener('quantity-selector:update', function () {
        render();
      });
    }

    var quantityInput = getQuantityInput();
    if (quantityInput) {
      quantityInput.addEventListener('input', render);
      quantityInput.addEventListener('change', render);
    }

    var sectionTarget = root.closest('.shopify-section, dialog');
    if (sectionTarget) {
      sectionTarget.addEventListener('variant:update', function (event) {
        if (!event || !event.detail || !event.detail.data) return;

        var eventProductId = event.detail.data.newProduct
          ? String(event.detail.data.newProduct.id)
          : String(event.detail.data.productId || '');

        if (eventProductId && productId && eventProductId !== String(productId)) return;

        setTimeout(render, 0);
      });
    }

    render();
  }

  function initAllStaffelBlocks() {
    document.querySelectorAll('[data-staffel-logik]').forEach(initStaffelBlock);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllStaffelBlocks);
  } else {
    initAllStaffelBlocks();
  }

  document.addEventListener('shopify:section:load', initAllStaffelBlocks);
})();
